"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSubjectToFinanceDto = instanceOfSubjectToFinanceDto;
exports.SubjectToFinanceDtoFromJSON = SubjectToFinanceDtoFromJSON;
exports.SubjectToFinanceDtoFromJSONTyped = SubjectToFinanceDtoFromJSONTyped;
exports.SubjectToFinanceDtoToJSON = SubjectToFinanceDtoToJSON;
exports.SubjectToFinanceDtoToJSONTyped = SubjectToFinanceDtoToJSONTyped;
/**
 * Check if a given object implements the SubjectToFinanceDto interface.
 */
function instanceOfSubjectToFinanceDto(value) {
    if (!('date' in value) || value['date'] === undefined)
        return false;
    if (!('bank' in value) || value['bank'] === undefined)
        return false;
    return true;
}
function SubjectToFinanceDtoFromJSON(json) {
    return SubjectToFinanceDtoFromJSONTyped(json, false);
}
function SubjectToFinanceDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'date': (new Date(json['date'])),
        'bank': json['bank'],
    };
}
function SubjectToFinanceDtoToJSON(json) {
    return SubjectToFinanceDtoToJSONTyped(json, false);
}
function SubjectToFinanceDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'date': value['date'].toISOString(),
        'bank': value['bank'],
    };
}
